(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./useQuery"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./useQuery"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.useQuery);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _useQuery) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_useQuery).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _useQuery[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _useQuery[key];
      }
    });
  });
});